import { retrieveCompanySettings, RetrieveCompanySettingsCallback, RetrieveCompanySettingsNotFoundCallback, CompanySettings, updateCompanySettings, UpdateCompanySettingsCallback, UserSettings, retrieveUserSettings, RetrieveUserSettingsCallback, RetrieveUserSettingsNotFoundCallback, UpdateUserSettingsCallback, replaceUserSettings } from "../api/SettingsApi";
import deepmerge from 'deepmerge';

class SettingsService {

  private static instance: SettingsService;
  private companySettings: CompanySettings | undefined;
  private employeeSettings: UserSettings | undefined;

  private constructor() { }

  public static getInstance(): SettingsService {
    if (!SettingsService.instance) {
      SettingsService.instance = new SettingsService();
    }
    return SettingsService.instance;
  }

  public async loadCompanySettings(): Promise<any> {
    const retrieveSettingsCallback: RetrieveCompanySettingsCallback = async (settings: CompanySettings) => {
      this.companySettings = this.getCompanySettingsWithDefaults(settings);
    };

    const retrieveSettingsNotFoundCallback: RetrieveCompanySettingsNotFoundCallback = async () => {
      this.updateCompanySettings(defaultCompanySettings);
    };

    await retrieveCompanySettings(retrieveSettingsCallback, retrieveSettingsNotFoundCallback);
    return this.companySettings;
  }

  public async loadUserSettings(): Promise<any> {
    const retrieveSettingsCallback: RetrieveUserSettingsCallback = async (settings: UserSettings) => {
      this.employeeSettings = this.getEmployeeSettingsWithDefaults(settings);
    };

    const retrieveSettingsNotFoundCallback: RetrieveUserSettingsNotFoundCallback = async () => {
      this.updateEmployeeSettings(defaultUserSettings);
    };

    await retrieveUserSettings(retrieveSettingsCallback, retrieveSettingsNotFoundCallback);
    return this.employeeSettings;
  }

  public async updateCompanySettings(settings: CompanySettings): Promise<any> {
    const updateSettingsCallback: UpdateCompanySettingsCallback = async (settings: CompanySettings) => {
      this.companySettings = settings;
    };

    await updateCompanySettings(settings, updateSettingsCallback);
    return this.companySettings;
  }

  public async updateEmployeeSettings(settings: UserSettings): Promise<any> {
    const updateSettingsCallback: UpdateUserSettingsCallback = async (settings: UserSettings) => {
      this.employeeSettings = settings;
    };

    await replaceUserSettings(settings, updateSettingsCallback);
    return this.employeeSettings;
  }

  public getSettings(): any {
    return this.companySettings;
  }

  private getCompanySettingsWithDefaults(retrievedSettings: Partial<CompanySettings>): CompanySettings {
    return deepmerge(defaultCompanySettings, retrievedSettings);
  };

  private getEmployeeSettingsWithDefaults(retrievedSettings: Partial<UserSettings>): UserSettings {
    return deepmerge(defaultUserSettings, retrievedSettings);
  };
}

export default SettingsService;

const defaultCompanySettings: CompanySettings = {
  displaySettings: {
    displayedEmployeeColumns: ['firstname', 'lastname', 'email', 'dateOfBirth']
  },
  timetracking: {
    showTotalHours: false,
    showFte: false,
    workingDays: [],
    absenceTypes: []
  }
};

const defaultUserSettings: UserSettings = {
  settings: {}
};